export const REJECT_STORE_VOUCHER_ERROR =
  'REJECT_STORE_VOUCHER_ERROR';
export const REJECT_STORE_VOUCHER_START =
  'REJECT_STORE_VOUCHER_START';
export const REJECT_STORE_VOUCHER_SUCCESS =
  'REJECT_STORE_VOUCHER_SUCCESS';
export const CLEAR_CANCEL_TRANSACTION = 'CLEAR_CANCEL_TRANSACTION';
